import React from "react";
import "./App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { BannerSlider } from "./components/BannerSlider";
import { BrandsSection } from "./components/BrandsSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[#f7f5f2]">
      <Header />
      <main>
        <HeroSection />
        <BannerSlider />
        <BrandsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
